import { Platform, View } from "react-native";

import { Text } from "@/components/ui/text";
import { NotificationsBell } from "@/features/notifications/NotificationsBell";
import { cn } from "@/lib/utils";

type ScreenTitleBarProps = {
    title: string;
    tone?: "default" | "onPrimary";
    className?: string;
};

/** Centered screen title with the notifications bell on the right. */
export function ScreenTitleBar({
    title,
    tone = "default",
    className,
}: ScreenTitleBarProps) {
    return (
        <View
            className={cn(
                "relative min-h-10 items-center justify-center px-4 web:mt-8",
                className,
            )}
        >
            <Text
                variant={Platform.OS === "web" ? "h3" : "label"}
                className={cn(
                    "px-10 text-center",
                    tone === "onPrimary" && "text-primary-foreground",
                )}
                numberOfLines={1}
            >
                {title}
            </Text>
            <View className="absolute right-4 top-0">
                <NotificationsBell tone={tone} />
            </View>
        </View>
    );
}
